







































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class TableRow extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly structure!: {};

  @Prop({ default: false }) readonly clickable!: boolean;

  stylePreset: { [key: string]: {} } = {
    default: {
      color: '#000000',
      fontSize: '14px',
      letterSpacing: '0',
      lineHeight: '20px',
    },
    label: {
      color: 'var(--color-green)',
      fontSize: '12px',
      letterSpacing: '0',
      lineHeight: '15px',
      padding: '2px 6px',
      borderRadius: '2px',
      backgroundColor: 'var(--color-green)20',
      border: '1px solid var(--color-green)90',
    },
  };

  private computedStyle(item: { style: any }) {
    if (typeof item.style === 'function') {
      return item.style.call({}, this.data);
    }

    if (Object.keys(this.stylePreset).includes(item.style)) {
      return this.stylePreset[item.style];
    }

    return this.stylePreset.default;
  }

  private computedValue(item: any) {
    if (typeof item.value === 'function') {
      return item.value.call({}, this.data);
    }

    return this.data[item.key];
  }

  @Emit('click')
  private handleRowClick() {
    if (this.clickable) {
      return true;
    }
  }
}
